import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

// Create axios instance
const axiosInstance = axios.create({
  baseURL: API_URL
});

// Request interceptor - add auth headers
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    const tenantId = localStorage.getItem('selectedTenantId');

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    const requestUrl = config.url || '';
    const shouldSendTenantHeader = tenantId && !requestUrl.startsWith('/crm/');

    if (shouldSendTenantHeader) {
      config.headers['X-Tenant-Id'] = tenantId;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle authentication errors
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Whitelist auth endpoints that should not trigger logout
    const authEndpoints = [
      '/auth/login',
      '/auth/complete-login',
      '/auth/password/migrate',
      '/auth/2fa/setup',
      '/auth/2fa/verify',
    ];

    // Check if the error is from a whitelisted endpoint
    const isAuthEndpoint = authEndpoints.some(endpoint =>
      error.config?.url?.includes(endpoint)
    );

    // Only logout if it's a 401/403 AND not from an auth endpoint
    if (error.response && (error.response.status === 401 || error.response.status === 403) && !isAuthEndpoint) {
      console.log('[Partner Portal] Authentication expired, logging out...');

      // Clear all authentication data
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('selectedTenantId');
      localStorage.removeItem('tempToken');

      // Redirect to login page
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
